import { FSAccessoryData, mapFSAccessoryDatas } from "../Accessory/AccessoryData";
import { FSColor, mapFSColor } from "../Color";
import { FSFileList, mapFSFileLists } from "../FileList";
import { FSDataOrder, mapFSDataOrder } from "../Order";
import { FSDoorSize, mapFSDoorSize } from "./DoorSize";

/* **************************************************** Finishing Shedule Door Data */
export interface FSDoorData {
    id: number;
    door_category: string;
    fs_data_id: number;
    color_id: number | null;
    fire_resistance_rating: 'FD30' | 'FD60' | null;
    size_type: 'Standard size' | 'Non standard size';
    size_id: number | null;
    manual_size: string | null;
    number: number | null;
    status: 'Prefinished' | 'Half-Finished' | 'Unfinished';
    note: string | null;
    image_path: string | null;
    file_list: FSFileList[];
    order_status: 'Pending' | 'Ordered' | 'Instore' | 'Onsite';
    order_date_data: string | null;
    order_date: string | null;
    order_data: FSDataOrder | null;
    color: FSColor | null;
    size: FSDoorSize | null;
}

export const mapFSDoorData = (data: any): FSDoorData => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSDoorData = {
        id: data.id,
        door_category: data.door_category,
        fs_data_id: data.fs_data_id,
        color_id: data.color_id || null,
        fire_resistance_rating: data.fire_resistance_rating || null,
        size_type: data.size_type,
        size_id: data.size_id || null,
        manual_size: data.manual_size || null,
        number: data.number || null,
        status: data.status,
        note: data.note || null,
        image_path: data.image_path || null,
        file_list: Array.isArray(data.file_list) ? mapFSFileLists(data.file_list) : [],
        order_status: data.order_status,
        order_date_data: data.order_date_data || null,
        order_date: data.order_date || null,
        order_data: data.order_data ? mapFSDataOrder(data.order_data) : null,
        color: data.color ? mapFSColor(data.color) : null,
        size: data.size ? mapFSDoorSize(data.size) : null,
    };

    return res;
};

export const mapFSDoorDatas = (data: any[]): FSDoorData[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSDoorData);
};


/* **************************************************** Finishing Shedule Door */
export interface FSDoor {
    id: number;
    fs_feature_id: number;
    category: string;
    location_name: string;
    location_id: number | null;
    is_default_feature: 1 | 0;
    data_door: FSDoorData[];
    data_accessory: FSAccessoryData[];
}

export const mapFSDoor = (data: any): FSDoor => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSDoor = {
        id: data.id,
        fs_feature_id: data.fs_feature_id,
        category: data.category,
        location_name: data.location_name,
        location_id: data.location_id || null,
        is_default_feature: data.is_default_feature,
        data_door: Array.isArray(data.data_door) ? mapFSDoorDatas(data.data_door) : [],
        data_accessory: Array.isArray(data.data_accessory) ? mapFSAccessoryDatas(data.data_accessory) : [],
    };

    return res;
};

export const mapFSDoors = (data: any[]): FSDoor[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSDoor);
};
